import { Button } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

export const SubmitButton = ({
  disabled,
  label = "submit",
  size = "sm",
  fill = "fill",
  type = "primary",
  loading,
}: {
  disabled?: boolean;
  loading?: boolean;
  label?: "save" | "submit";
  size?: "xs" | "sm" | "md";
  fill?: "fill" | "outline" | "transparent";
  type?:
    | "default"
    | "primary"
    | "secondary"
    | "danger"
    | "warning"
    | "success"
    | "dark"
    | "light"
    | "info";
}) => {
  const { language } = useLanguage();

  return (
    <Button
      fill={fill}
      size={size}
      type={type}
      htmlType="submit"
      disabled={disabled}
      loading={loading}
    >
      {label === "save"
        ? language === "bn"
          ? "সংরক্ষণ করুন"
          : "Save"
        : language === "bn"
        ? "জমা দিন"
        : "Submit"}
    </Button>
  );
};
